import { render, staticRenderFns } from "./RequestDocumentsTable.vue?vue&type=template&id=52604730&"
import script from "./RequestDocumentsTable.vue?vue&type=script&lang=js&"
export * from "./RequestDocumentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports